import { TOKEN } from "@/types/common/ids";
import { Org, OrgAdmin, OrgFeatures } from "@/types/org";
import { apiFetch } from "@/lib/api";
import { GAIL_API } from "@/utils/common/constants/routes";
import { GetServerToken } from "@/utils/common/serverSide";

/**
 * Fetches the current organization.
 *
 * @param accessToken - Access token for server-side usage.
 */
export const GetOrg = async (accessToken?: TOKEN): Promise<Org | null> => {
  return await apiFetch<Org>(
    `${GAIL_API}/.internal/customer/organization`,
    "GET",
    {
      accessToken,
    }
  );
};

/**
 * Fetches the current organization's features via the dedicated features endpoint.
 * This avoids the DTO chain in the main org GET that can lose fields.
 */
export const GetOrgFeatures = async (accessToken?: TOKEN): Promise<OrgFeatures | null> => {
  return await apiFetch<OrgFeatures>(
    `${GAIL_API}/.internal/customer/organization/features`,
    "GET",
    {
      accessToken,
    }
  );
};

/**
 * Fetches the current organization using the server token.
 *
 * @param agencyId - The agency ID to fetch the organization for.
 */
export const GetOrgAdmin = async (
  agencyId: string | null
): Promise<OrgAdmin | null> => {
  if (!agencyId) {
    return null;
  }

  const serverToken = await GetServerToken();

  return await apiFetch<OrgAdmin>(
    `${GAIL_API}/.internal/admin/organization`,
    "GET",
    {
      headers: {
        Authorization: `Bearer ${serverToken}`,
        "X-Org-ID": agencyId,
      },
    }
  );
};
